import React from 'react'
import Image from '../../../common/footer/Images/Image'


function VideoContentWidgetStencil() {
    return (
        <div>
            {[0]?.map((elm, i) => (
                <div class={`edu-blog-widget-2 widget-latest-post`} key={i}>
                    <div class="inner y-gap-40">
                        <div class="content latest-post-list">
                            <div class="latest-post">
                                <div class="thumbnail">
                                    <div class="d-block img-popular-video clickable">
                                        <Image src="#" className="rounded-16" alt="Thumbnail" fill />
                                    </div>
                                </div>
                                <div className='w-100 mt--10'>
                                    <h6 className='mb--10'>
                                        <div className="price w-100 placeholder placeholder-glow "></div>
                                    </h6>
                                    <div>
                                        <div className="price w-25 h-100 placeholder placeholder-glow"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default VideoContentWidgetStencil
